import { getApplications } from "api/applications";
import constate from "constate";
import { useFetchedState } from "hooks/useFetchedState";

const useApplications = () => {
  const { data: applications, loadData: loadApplications } = useFetchedState(getApplications);

  return {
    actions: { loadApplications },
    state: { applications },
  };
};

export const [ApplicationsProvider, useApplicationsContext] = constate(useApplications);
